import { showNotification } from '../../../../../../app/common/helpers/notifications';
import { useToggle } from '../../../../../infra/small-tools/use-toggle';
import { useApiQuery } from '../../../../../infra/api';
import { endpoints } from '../network/endpoints';
export var usePlatformCredentialsHandlers = function (_a) {
    var barberId = _a.barberId, platform = _a.platform;
    var _b = useApiQuery({
        endpoint: endpoints.externalPlatformCredentialsQuery,
        payload: {
            barberId: barberId,
            platform: platform,
        },
        options: {
            enabled: !!barberId && !!platform,
        },
    }), credentials = _b.data, isLoadingCredentials = _b.isLoading, isErrorCredentials = _b.isError;
    var copyTextToClipboard = function (text) {
        if (text) {
            try {
                navigator.clipboard.writeText(text);
                showNotification({
                    title: 'Copied',
                    message: 'Text copied to clipboard.',
                    autoDismiss: 5,
                });
            }
            catch (e) {
                showNotification({
                    title: 'Failed to copy',
                    message: 'Failed to copy text to clipboard. Please copy manually.',
                    autoDismiss: 5,
                });
            }
        }
    };
    var handleCopyLoginClicked = function () {
        var _a;
        copyTextToClipboard((_a = credentials === null || credentials === void 0 ? void 0 : credentials.login) === null || _a === void 0 ? void 0 : _a.trim());
    };
    var handleCopyPasswordClicked = function () {
        var _a;
        copyTextToClipboard((_a = credentials === null || credentials === void 0 ? void 0 : credentials.password) === null || _a === void 0 ? void 0 : _a.trim());
    };
    var showPassword = useToggle(false);
    return {
        login: credentials === null || credentials === void 0 ? void 0 : credentials.login,
        onCopyLoginClicked: handleCopyLoginClicked,
        password: credentials === null || credentials === void 0 ? void 0 : credentials.password,
        onCopyPasswordClicked: handleCopyPasswordClicked,
        shouldShowPassword: showPassword.isOn,
        onShowPasswordClicked: showPassword.toggle,
        isLoadingCredentials: isLoadingCredentials,
        isErrorCredentials: isErrorCredentials,
    };
};
